import React from 'react';
import { Typography, Button, Stack, Box, CircularProgress } from '@mui/material';
import SportsGymnasticsIcon from '@mui/icons-material/SportsGymnastics';
import { useSession } from '@platform/core/src/context/SessionContext';
import { useUI } from '@platform/core/src/context/UIContext';

const WorkoutSessionCompletedMessage = () => {
  const { initializeSession, isInitializing } = useSession();
  const { closeAllResourceTabs } = useUI();
  const workoutSessionPreChatConfig = [
    {
      resourceType: 'location',
      label: 'Location (Optional)',
      max: 1,
      optional: true,
    },
    {
      resourceType: 'workout_plan',
      label: 'Workout Plan (Optional)',
      max: 1,
      optional: true,
    },
  ];

  const handleStartSession = async () => {
    try {
      closeAllResourceTabs();
      await initializeSession(null, {
        team_name: 'active_workout_team',
        preChatConfig: workoutSessionPreChatConfig,
      });
    } catch (error) {
      console.error('Failed to start new session from workout completed message:', error);
    }
  };

  return (
    <Stack spacing={2} sx={{ maxWidth: '100%' }}>
      <Typography variant="h6">
        Workout Complete!
      </Typography>
      <Typography variant="body1">
        Great job finishing your session. Ready for the next one?
      </Typography>
      <Box>
        <Button
          variant="contained"
          onClick={handleStartSession}
          disabled={isInitializing}
          startIcon={isInitializing ? <CircularProgress size={20} color="inherit" /> : <SportsGymnasticsIcon />}
        >
          Start New Session
        </Button>
      </Box>
    </Stack>
  );
};

export default WorkoutSessionCompletedMessage;